import React, {useState} from 'react';
import classNames from "classnames";

export const base_url = process.env.MIX_ENV_LOCAL ? "http://trikotaktion.test" : "";

const VoteBox = (
  {
    node,
    id,
    csrf,
  }) => {

  const [numberSent, setNumberSent] = useState(false);
  const [phone, setPhone] = useState('');
  const [error, setError] = useState(null);
  const [code, setCode] = useState(null);
  const [result, setResult] = useState(null); // Also with cookie?

  const preVote = () => {
    const form = new FormData();
    form.append('phone', phone);
    form.append('_token', csrf);
    // Send to server
    fetch(`${base_url}/projects/${id}/prevote`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
      },
      body: form,
    })
      .then(response => response.json())
      .then(data => {
        if (!data.success) {
          setError(data.error);
          setNumberSent(0);
        } else {
            setNumberSent(Date.now(), { days: 1 });
        }
        console.log(data);
      })
  }

  const sendVote = () => {
    const form = new FormData();
    form.append('code', code);
    form.append('phone', phone);
    form.append('_token', csrf);
    // Send to server
    fetch(`${base_url}/projects/${id}/vote2`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
      },
      body: form,
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === 'success') {
          setResult(1);
        } else {
          setError(data.error);
          // setResult(2);
          // Reset form state?
        }
        // console.log(data);
      })
  }

  // numberSent is fewer then 10 minutes ago
  const activeNumberSent = numberSent && Date.now() - numberSent < 600000;

  return (
    <div className="vote-box">
      <div className="vote-box__title">
        <h3>Jetzt abstimmen!</h3>
      </div>
      <div className="vote-box__content">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            preVote()
          }}
          className={classNames("vote-box__preform", {"vote-box__preform--show": !activeNumberSent && !result})}
        >
          <div className="vote-box__content__text">
            <p>
                Um abzustimmen geben Sie bitte eine Mobilnummer ein. Sie erhalten per SMS einen Code, mit dem Sie Ihre
                Stimme freigeben können. Es sind nur deutsche Mobilfunknetze erlaubt. Wenn Sie bereits einen Code
                angefordert haben, warten Sie bitte zehn Minuten, bevor Sie einen neuen anfordern.
            </p>
            <p>Wir verwenden Ihre Mobilnummer nur zur Absicherung unseres Votings und speichern sie nur für den Abgleich verschlüsselt.</p>
          </div>
          {error ? (
            <div className="vote-box__content__error">
              <p>{error}</p>
            </div>
          ) : null}
          <input type="text" placeholder="Ihre Mobilnummer" value={phone}
                 onChange={(e) => {
                   setError('');
                   setPhone(e.target.value)
                 }}/>
          <button type="submit">Code anfordern</button>
        </form>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            sendVote();
          }}
          className={classNames("vote-box__voteform", {"vote-box__voteform--show": true})}
        >
          {result === 1 ? (
            <div className="vote-box__content__error">
              <p>Vielen Dank, Ihre Stimmabgabe wurde erfolgreich aufgezeichnet.</p>
            </div>
          ) : <>
            { numberSent ? (
                <p>
                  Vielen Dank. Geben Sie jetzt bitte den sechsstelligen Code ein, den Sie per SMS bekommen
                  haben. Wenn Sie keinen Code erhalten haben, können Sie nach zehn Minuten einen neuen anfordern.
                </p>
            ) : (
                <p>
                    Wenn Sie bereits einen Code erhalten haben, geben Sie diesen bitte hier ein.
                </p>
            )}
            <input type="text" placeholder="Ihr Voting-Code" value={code}
                   onChange={(e) => setCode(e.target.value)}/>
            <button type="submit">Jetzt abstimmen</button>
          </>}
        </form>
      </div>
    </div>
  );
}

export default VoteBox;
